/**
 * Decides whether a Mac project chat must render read-only (history visible,
 * composer blocked).
 *
 * Web cannot control Mac project chats. Mobile requires a connected Mac; send
 * controls still verify current access before running. Empty history alone does
 * not establish a disconnected Mac or revoked access.
 */
export function resolveMacProjectReadOnly({
  platform,
  isMacProjectChat,
  revokedAt,
  remoteConnection,
} = {}) {
  if (!isMacProjectChat) return false;
  if (platform === 'web') return true;
  if ((platform === 'ios' || platform === 'android') && remoteConnection && remoteConnection !== 'connected') return true;

  return !!revokedAt;
}

export default resolveMacProjectReadOnly;
